import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
import HelperForMetaData from "../../helpers/HelperForMetaData";

const CreateLeads = async (e) => {
  console.log("duplicateDocsExist", e);
  /**
   * input: null
   * output: lead document / collection
   * description: create lead / lead document
   */
  try {
    const leadsCollection = await collection(db, "leads");

    /** Check if new lead duplicates, return */
    const q = query(
      leadsCollection,
      where("cnic", "==", e.cnic),
      where("bid", "==", getLocalStorageItem("bid"))
    );
    if (e.cnic !== null) {
      const duplicateDocs = await getDocs(q);
      const duplicateDocsExist = duplicateDocs.docs.length > 0 ? true : false;

      console.log("duplicateDocsExist", duplicateDocsExist);
      if (duplicateDocsExist) return null;
    }

    const data = HelperForMetaData({
      ...e,
      bid: getLocalStorageItem("bid"),
    });
    const result = await addDoc(leadsCollection, data);

    console.log("result", result);
    return result;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateLeads;
